import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { ColoredTextItem } from 'src/app/domainObjects/coloredTextItem';

@Component({
    selector: 'app-autocomplete-field-delete-filter',
    templateUrl: './autocomplete-field-delete-filter.component.html',
    styleUrls: ['./autocomplete-field-delete-filter.component.css'],
    standalone: false
})
export class AutocompleteFieldDeleteFilterComponent implements OnInit {
  @Input() options: string[] = []; // Options for the autocomplete
 // @Input() formControl!: FormControl; // Control for the field itemcolor
  @Input() item: ColoredTextItem;
  @Output() deleteItem = new EventEmitter<ColoredTextItem>();
  formControl:FormControl;

  filteredOptions!: Observable<string[]>;
  private onChange: (value: any) => void = () => {};
  private onTouched: () => void = () => {};
  ngOnInit() {
    this.formControl= new FormControl();
   
    //console.log("value auto c :",this.value);
    // Initialize filtering logic
    this.filteredOptions = this.formControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || ''))
    );

    // Emit changes to ngModel whenever the form control value changes
    this.formControl.valueChanges.subscribe(value => {
      this.onChange(value);
      this.onTouched();
    });
  }
// Write a new value to the element
writeValue(value: any): void {
  this.formControl.setValue(value, { emitEvent: false });
}

// Set the function to be called when the control receives a change event
registerOnChange(fn: any): void {
  this.onChange = fn;
}

// Set the function to be called when the control receives a touch event
registerOnTouched(fn: any): void {
  this.onTouched = fn;
}
  // Private method to filter options based on input value
  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.options.filter(option => option.toLowerCase().includes(filterValue));
  }
  onDeleteItem(item:ColoredTextItem){
    this.deleteItem.emit(item);
  }
}
